module.exports = __webpack_public_path__ + "static/media/29COICT10.28377c6b.jpg";